// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "optimizer/v1/date_schedule.proto" (package "optimizer.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
/**
 * Mirrors the optimizer's Date_Schedule classes one-to-one. Converted to/from them via
 * Date_Schedule.from_proto / Date_Schedule.to_proto. (Daily == NDayPeriodic(1).)
 *
 * @generated from protobuf message optimizer.v1.DateSchedule
 */
export interface DateSchedule {
    /**
     * @generated from protobuf oneof: schedule
     */
    schedule: {
        oneofKind: "monthlyRecurring";
        /**
         * @generated from protobuf field: optimizer.v1.MonthlyRecurringDateSchedule monthly_recurring = 1;
         */
        monthlyRecurring: MonthlyRecurringDateSchedule;
    } | {
        oneofKind: "nDayPeriodic";
        /**
         * @generated from protobuf field: optimizer.v1.NDayPeriodicSchedule n_day_periodic = 2;
         */
        nDayPeriodic: NDayPeriodicSchedule;
    } | {
        oneofKind: "yearlyRecurring";
        /**
         * @generated from protobuf field: optimizer.v1.YearlyRecurringDateSchedule yearly_recurring = 3;
         */
        yearlyRecurring: YearlyRecurringDateSchedule;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message optimizer.v1.MonthlyRecurringDateSchedule
 */
export interface MonthlyRecurringDateSchedule {
    /**
     * @generated from protobuf field: int32 period = 1;
     */
    period: number;
    /**
     * @generated from protobuf field: int32 recurrence_day_of_month = 2;
     */
    recurrenceDayOfMonth: number;
}
/**
 * @generated from protobuf message optimizer.v1.NDayPeriodicSchedule
 */
export interface NDayPeriodicSchedule {
    /**
     * @generated from protobuf field: int32 period = 1;
     */
    period: number;
}
/**
 * @generated from protobuf message optimizer.v1.YearlyRecurringDateSchedule
 */
export interface YearlyRecurringDateSchedule {
    /**
     * @generated from protobuf field: int32 period = 1;
     */
    period: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class DateSchedule$Type extends MessageType<DateSchedule> {
    constructor() {
        super("optimizer.v1.DateSchedule", [
            { no: 1, name: "monthly_recurring", kind: "message", oneof: "schedule", T: () => MonthlyRecurringDateSchedule },
            { no: 2, name: "n_day_periodic", kind: "message", oneof: "schedule", T: () => NDayPeriodicSchedule },
            { no: 3, name: "yearly_recurring", kind: "message", oneof: "schedule", T: () => YearlyRecurringDateSchedule }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message optimizer.v1.DateSchedule
 */
export const DateSchedule = new DateSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MonthlyRecurringDateSchedule$Type extends MessageType<MonthlyRecurringDateSchedule> {
    constructor() {
        super("optimizer.v1.MonthlyRecurringDateSchedule", [
            { no: 1, name: "period", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "recurrence_day_of_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message optimizer.v1.MonthlyRecurringDateSchedule
 */
export const MonthlyRecurringDateSchedule = new MonthlyRecurringDateSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class NDayPeriodicSchedule$Type extends MessageType<NDayPeriodicSchedule> {
    constructor() {
        super("optimizer.v1.NDayPeriodicSchedule", [
            { no: 1, name: "period", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message optimizer.v1.NDayPeriodicSchedule
 */
export const NDayPeriodicSchedule = new NDayPeriodicSchedule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class YearlyRecurringDateSchedule$Type extends MessageType<YearlyRecurringDateSchedule> {
    constructor() {
        super("optimizer.v1.YearlyRecurringDateSchedule", [
            { no: 1, name: "period", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message optimizer.v1.YearlyRecurringDateSchedule
 */
export const YearlyRecurringDateSchedule = new YearlyRecurringDateSchedule$Type();
